@if(bookingList(); as bookingListViewModel){
<div class="marginBottom-l">
  <vy-menu-horizontal [items]="bookingListViewModel.horizontalMenuItems">
    <vy-avatar-name
      header-left
      [avatarInput]="bookingListViewModel.avatar"
      [avatarCustomName]="'common.horizontal_nav_bar.salutation' | translate: {user:bookingListViewModel.userName }"
    ></vy-avatar-name>
  </vy-menu-horizontal>
</div>

<h1 class="headingXXL marginBottom-l">{{'booking_list_component.title' | translate}}</h1>

<vy-box [boxLevel]="BoxLevel.LEVEL_MAIN">
  <ng-container box-content>
    <vy-box [boxLevel]="BoxLevel.LEVEL_ONE">
      <ng-container box-content>
        <div class="booking-list-content marginBottom-m">
          <vy-segmented-controls [options]="quickFilters" (optionEmitter)="changeQuickFilter($event)">
          </vy-segmented-controls>

          <vy-button
            label="{{'booking_list_component.filters.filter_button' | translate}}"
            (click)="openFiltersSidePanel()"
            onkeypress="openFiltersSidePanel()"
            [iconRight]="'ds-icon-filter'"
            [type]="ButtonType.OUTLINE_SECONDARY"
            [size]="ButtonSize.S"
          ></vy-button>
        </div>

        <div class="booking-list-chips marginBottom-l">
          @for (chip of currentChips; track $index) {
          <vy-chip [chip]="chip" (chipCloseEventEmitter)="deleteFilter($event)"></vy-chip>
          }
        </div>

        <div class="count-buttons-align">
          <div class="marginLeft-s">
            @if ((bookingListViewModel.totalBookingsFound ?? 0) > 1) {
            <p
              [innerHTML]="'booking_list_component.found_bookings.plural' | translate: { count:
              bookingListViewModel.totalBookingsFound }"
            ></p>
            } @else if(bookingListViewModel.totalBookingsFound === 1) {
            <p [innerHTML]="'booking_list_component.found_bookings.singular' | translate"></p>
            }
          </div>
          <div class="marginRight-s">
            <app-export-booking-list
              [typeBookings]="'Standard'"
              (loading)="$event ? startLoading() : stopLoading()"
            ></app-export-booking-list>
          </div>
        </div>

        <div>
          <vy-loader [whiteBackground]="true" [parentRelative]="true"></vy-loader>
          @if (bookingListViewModel.bookingsTableData && bookingListViewModel.bookingsTableData.bodyData.length > 0 ) {

          <app-booking-table
            [tableConfig]="bookingListViewModel.bookingsTableData"
            (sort)="onSort($event)"
          ></app-booking-table>

          <vy-paginator
            [currentPage]="bookingListViewModel.paginationInfo.currentPage ?? 0"
            [totalPages]="bookingListViewModel.paginationInfo.totalPages ?? 0"
            (pageChange)="changePage($event)"
          ></vy-paginator>

          } @else {

          <div class="marginTop-xl marginBottom-xl">
            <vy-box>
              <ng-container box-content>
                <div class="text-center padding-l">
                  <h3 class="headingL marginBottom-l">
                    {{ 'booking_list_component.no_filtered_bookings' | translate }}
                  </h3>
                  <img [src]="bookingsNotFoundImage" alt="" />
                </div>
              </ng-container>
            </vy-box>
          </div>

          }
        </div>
      </ng-container>
    </vy-box>
  </ng-container>
</vy-box>
}
